import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";

const ManageSubadminRoles = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  return (
    <>
      <CommonBreadcrumb
        title="Manage Roles"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage Sub-Admin", onClick: () => navigate("/manage-subadmin") },
          { label: "Manage Roles" },
        ]}
      />
      
      <div className="cards">
        <RolesListTopbar setSearch={setSearch} />
        <RolesList search={search} />
      </div>
    </>
  );
};

export default ManageSubadminRoles;
